import React from 'react';
import { Loader2 } from 'lucide-react';
// DENS CAKRA — Splash / boot screen shown on initial application load.
export function SplashScreen() {
  return <div className="fixed inset-0 z-[100] bg-background bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')] bg-repeat flex flex-col items-center justify-center animate-in fade-in duration-300" data-id="element-497">
      <div className="absolute inset-0 bg-gradient-to-b from-background/70 to-background pointer-events-none" data-id="element-498" />

      <div className="relative flex flex-col items-center text-center px-6" data-id="element-499">
        <div className="w-24 h-24 flex items-center justify-center mb-6 animate-in zoom-in duration-500" data-id="element-500">
          <img src="https://cdn.magicpatterns.com/uploads/hos8i69ZV8fMbtkJgKVvED/Logo_BIN_NEW.png" alt="Logo Badan Intelijen Negara Republik Indonesia" className="w-full h-full object-contain drop-shadow-[0_0_30px_rgba(var(--primary),0.3)]" data-id="element-501" />
        </div>

        <h1 className="text-4xl font-heading font-bold tracking-[0.3em] text-primary text-glow-primary" data-id="element-502">
          DENS CAKRA
        </h1>
        <p className="text-[11px] uppercase tracking-widest text-foreground/80 font-mono mt-3 max-w-md leading-relaxed" data-id="element-503">
          Dashboard Evaluasi Nasional dan Situational Awareness - Command,
          Analytic, Knowledge, Response &amp; Awareness
        </p>

        <div className="flex items-center gap-2 mt-10 text-primary/80" data-id="element-504">
          <Loader2 className="w-4 h-4 animate-spin" data-id="element-505" />
          <span className="text-xs font-mono uppercase tracking-widest" data-id="element-506">
            Loading System...
          </span>
        </div>

        <p className="text-[10px] italic tracking-wider text-primary/60 font-mono mt-8" data-id="element-507">
          "Velox Et Exactus"
        </p>
      </div>
    </div>;
}